
import { PPI, BLEED, MATERIAL_THICKNESS } from './constants';

class Base {

  width = 0;
  widthInPx = 0;

  length = 0;
  lengthInPx = 0;

  depth = 0;
  depthInPx = 0;

  inch = 1;
  inchInPx = 0;
  pixelsPerInch = 0;

  bleed = 0;
  bleedInPx = 0;

  materialThickness = MATERIAL_THICKNESS;
  materialThicknessInPx = MATERIAL_THICKNESS * PPI;

  canvasWidth = 0;
  canvasHeight = 0;

  baseObjectSize = 0;
  baseControlSize = 0;
  baseRotationPointOffset = 0;

  ratio = 0;

  geometrySvg = null;
  maskSvg = null;
  clipPathSvg = null;

  // @TODO document this
  constructor(params) {
    this.setDimensions(params);

    this.widthInPx = this.width * this.pixelsPerInch;
    this.lengthInPx = this.length * this.pixelsPerInch;
    this.depthInPx = this.depth * this.pixelsPerInch;
    this.materialThicknessInPx = this.materialThickness * this.pixelsPerInch;
    this.bleedInPx = this.bleed * this.pixelsPerInch;
    this.inchInPx = this.pixelsPerInch;
  }

  setDimensions(params) {
    this.width = params.width;
    this.length = params.length;
    this.depth = params.depth;

    this.bleed = BLEED;
    this.materialThickness = MATERIAL_THICKNESS;
    this.pixelsPerInch = PPI;
  }

  setControlsSize() {
    // switched from /16 to /10 because /16 was to small
    this.baseObjectSize = this.canvasHeight / 8;

    if (window.innerWidth < 2000) {
      this.baseControlSize = 15;
      this.baseRotationPointOffset = -(this.baseControlSize * 3);
    } else {
      this.baseControlSize = 20;
      this.baseRotationPointOffset = -(this.baseControlSize * 2.5);
    }
  }

  getScale(scaleX, scaleY) {
    return Math.min(scaleX, scaleY);
  }

  getWidth() {
    return this.width;
  }

  getLength() {
    return this.length;
  }

  getDepth() {
    return this.depth;
  }

  getMaterialThickness() {
    return this.materialThickness;
  }

  // generateSvgs() {
  //   const svgs = getSvgs(this);

  //   this.geometrySvg = svgs.geometrySvg;
  //   this.maskSvg = svgs.maskSvg;
  //   this.outlineShapePathNormalized = svgs.outlineShapePathNormalized;
  //   this.outlineShapePath = svgs.outlineShapePath;
  // }
}

export default Base;
